import { createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c51990c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radius-slide-container" }
const _hoisted_2 = {
  class: "text",
  ref: "textContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "slider-wrapper",
      ref: "wrapper",
      style: _normalizeStyle({ width: '4px', height: $props.height })
    }, [
      _createCommentVNode(" filled 높이 "),
      _createElementVNode("div", {
        class: "filled",
        style: _normalizeStyle({ height: $setup.rangeFilledHeight })
      }, null, 4 /* STYLE */),
      _createVNode($setup["VerticalSlider"], {
        class: "slider",
        modelValue: $setup.selectedRadiusIndex,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedRadiusIndex) = $event)),
        min: 0,
        max: $setup.N - 1
      }, null, 8 /* PROPS */, ["modelValue", "max"])
    ], 4 /* STYLE */),
    _createCommentVNode(" 레이블: reverse 해서 0이 맨 아래 "),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reversedList, (radius, i) => {
        return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString($setup.displayRadiusText(radius)), 1 /* TEXT */))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */)
  ]))
}